import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Box, ClickAwayListener, Grow, Paper, Popper } from '@mui/material'

export default forwardRef(
  (
    {
      anchorElt,
      anchorSx = {},
      paperstyle,
      onOpen = () => {},
      onClickOutside = () => {},
      children,
      ...popperProps
    },
    ref
  ) => {
    const [isOpen, setIsOpen] = useState(false)
    const anchorRef = useRef(null)

    useImperativeHandle(ref, () => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    }))
    
    const handleToggle = () => {
      setIsOpen((prevOpen) => {
        onOpen(!prevOpen)
        return !prevOpen
      })
    }

    const handleClose = (event) => {
      if (
        anchorRef.current &&
        event &&
        anchorRef.current.contains(event.target)
      ) {
        return
      }
      onOpen(false)
      onClickOutside()
      setIsOpen(false)
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(isOpen)
    React.useEffect(() => {
      if (prevOpen.current === true && !isOpen) {
        anchorRef.current.focus()
      }

      prevOpen.current = isOpen
    }, [isOpen])

    return (
      <>
        <Box
          ref={anchorRef}
          sx={anchorSx}
        >
          {React.cloneElement(anchorElt, { onClick: handleToggle })}
        </Box>
        <Popper
          {...popperProps}
          open={isOpen}
          anchorEl={anchorRef.current}
          transition
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: 'center bottom' }}
            >
              <Paper style={paperstyle}>
                <ClickAwayListener onClickAway={handleClose} mouseEvent="onMouseDown">
                  {children}
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    )
  }
)
